import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { BodyClass } from '@plone/volto/helpers';
import { Button, Dropdown } from 'semantic-ui-react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUniversalAccess, faCircleHalfStroke } from '@fortawesome/free-solid-svg-icons';


const A11Y = () => {
  const [darkMode, setDarkMode] = useState(false);
  const [fontSizeMode, setFontSizeMode] = useState('regular');

  const triggerMnA11y = (
    <div className='mnA11y__trigger' role='presentation'>
      <FontAwesomeIcon icon={faUniversalAccess} />
      <span className="visually-hidden"><FormattedMessage id="Customize page" defaultMessage="Customize page" /></span>
    </div>
  );

  const handleContrastClick = () => {
    setDarkMode(!darkMode);
  };

  const fontSwitchSmall = () => {
    document.documentElement.style.fontSize = "12px";
    setFontSizeMode('small');
  };
  const fontSwitchRegular = () => {
    document.documentElement.style.fontSize = null;
    setFontSizeMode('regular');
  };
  const fontSwitchBig = () => {
    document.documentElement.style.fontSize = "24px";
    setFontSizeMode('big');
  };

  useEffect(() => {
    if (typeof window !== 'undefined') {
      const storedDarkMode = JSON.parse(localStorage.getItem('darkMode'), false);
      const storedFontSize = JSON.parse(localStorage.getItem('fontSizeMode'), false);
      setDarkMode(storedDarkMode)
      setFontSizeMode(storedFontSize)
    }
  }, []);

  useEffect(() => {
    if (typeof window !== 'undefined') {
      localStorage.setItem('darkMode', darkMode);
      localStorage.setItem('fontSizeMode', JSON.stringify(fontSizeMode) );
    }

    if (darkMode) {
      document.body.classList.add('highContrast');
    } else {
      document.body.classList.remove('highContrast');
    }

    if (fontSizeMode == 'small' ) {
      document.documentElement.style.fontSize = "12px";
    }
    if (fontSizeMode == 'regular' ) {
      document.documentElement.style.fontSize = null;
    }
    if (fontSizeMode == 'big' ) {
      document.documentElement.style.fontSize = "24px";
    }
  }, [darkMode, fontSizeMode]);

  return (
    <>
      <BodyClass className={ darkMode ? 'highContrast' : 'noContrast'} />  
      <BodyClass className={ ( fontSizeMode == 'small' ) ? 'fontSmall' : ''} />  
      <BodyClass className={ ( fontSizeMode == 'regular' ) ? 'fontRegular' : ''} />  
      <BodyClass className={ ( fontSizeMode == 'big' ) ? 'fontBig' : ''} />
      
      <Dropdown
        button
        className='mnA11y'
        trigger={triggerMnA11y} basic >
        <Dropdown.Menu className='list-unstyled my-0 mnA11y__list' role='presentation'>                
          <Dropdown.Item>
              <Button.Group>
                <Button basic onClick={fontSwitchSmall} className=" topBar__btn fontSwitch fontSwitch--small fs-sm">A-
                  <span className="visually-hidden"><FormattedMessage id="Decrease font size" defaultMessage="Decrease font size" /></span>
                </Button>
                <Button basic onClick={fontSwitchRegular} className="fontSwitch  topBar__btn fontSwitch--regular">A
                  <span className="visually-hidden"><FormattedMessage id="Reset font size" defaultMessage="Reset font size" /></span>
                </Button>
                <Button basic onClick={fontSwitchBig} className="fontSwitch  topBar__btn fontSwitch--big fs-lg">A+
                  <span className="visually-hidden"><FormattedMessage id="Increase font size" defaultMessage="Increase font size" /></span>
                </Button>
              </Button.Group>
          </Dropdown.Item>
          <Dropdown.Item className='ms-md-3'>
            <Button basic className="constrastToggle topBar__btn" onClick={handleContrastClick}>
              <FontAwesomeIcon icon={faCircleHalfStroke} />
              <span className="constrastToggle__text"><FormattedMessage id="Contrast" defaultMessage="Contrast" /></span>
            </Button>
          </Dropdown.Item>
        </Dropdown.Menu>
      </Dropdown>
    </>
  );
};

export default A11Y;